import { Component, OnInit, Input } from '@angular/core';
import { Partner, ImageDescription, PartnerButton } from '@fitscovery/partner/data-access';
import { UtilCustomButtonAlignment } from '../../../../shared/util';

@Component({
  selector: 'fitscovery-ui-default-section-odd',
  templateUrl: './ui-default-section-odd.component.html',
  styleUrls: ['./ui-default-section-odd.component.scss', '../partner-homepage-default-style.scss']
})
export class UiDefaultSectionOddComponent implements OnInit {
  @Input() partner: Partner;
  @Input() imageDescription: ImageDescription;

  constructor() { }

  ngOnInit(): void {
  }

  setButtonAlignmentClass(button: PartnerButton): string {
    return UtilCustomButtonAlignment.setButtonAlignment(button)!;
  }
}
